import { getIsValidString } from "@/utils/functions";

type CustomerAddress = {
  zipcode?: string;
  streetName?: string;
  number?: string;
  city?: string;
  state?: {
    name?: string;
  };
  main?: boolean;
};

type CustomerClient = {
  addresses?: CustomerAddress[];
};

type CustomerWithAddressSession = {
  fromWebAccessToken?: boolean;
  client?: CustomerClient;
};

export function hasCustomerAddress(client?: CustomerClient): boolean {
  const addresses = client?.addresses;
  if (!Array.isArray(addresses) || addresses.length === 0) {
    return false;
  }

  const address = addresses.find((item) => item?.main) ?? addresses[0];

  return Boolean(
    getIsValidString(address?.zipcode) &&
      getIsValidString(address?.streetName) &&
      getIsValidString(address?.number) &&
      getIsValidString(address?.city) &&
      getIsValidString(address?.state?.name),
  );
}

/** Salto logado (WebAccessToken) sem endereço no UserData. */
export function needsAddressForPayment(
  customer?: CustomerWithAddressSession | null,
): boolean {
  return Boolean(
    customer?.fromWebAccessToken && !hasCustomerAddress(customer?.client),
  );
}
